export const CourierProviderMock = [
  {
    courierProviderId: 1,
    courierProviderName: "Professional Courier",
    stateId: 1,
    stateName: "Kerala",
    criteria: "Up to 5 Kgs",
    weightSlab: "5kg to 10kg",
    charges: 40.0,
  },
  {
    courierProviderId: 2,
    courierProviderName: "Professional Courier",
    stateId: 1,
    stateName: "Kerala",
    criteria: "5kg to 10kg",
    weightSlab: "5kg to 10kg",
    charges: 35.0,
  },
  {
    courierProviderId: 3,
    courierProviderName: "Professional Courier",
    stateId: 1,
    stateName: "Kerala",
    criteria: "5kg to 10kg",
    weightSlab: "10kg to 15kg",
    charges: 30.0,
  },
  {
    courierProviderId: 4,
    courierProviderName: "Professional Courier",
    stateId: 1,
    stateName: "Kerala",
    criteria: "15kg to 20kg",
    weightSlab: "10kg to 15kg",
    charges: 25.0,
  },
  {
    courierProviderId: 5,
    courierProviderName: "Professional Courier",
    stateId: 1,
    stateName: "Kerala",
    criteria: "20kg above",
    weightSlab: "10kg to 15kg",
    charges: 25.0,
  },
  {
    courierProviderId: 6,
    courierProviderName: "DTDC",
    stateId: 1,
    stateName: "Kerala",
    criteria: "Up to 5 Kgs",
    weightSlab: "5kg to 10kg",
    charges: 50.0,
  },
  {
    courierProviderId: 7,
    courierProviderName: "DTDC",
    stateId: 1,
    stateName: "Kerala",
    criteria: "5kg to 10kg",
    weightSlab: "5kg to 10kg",
    charges: 45.0,
  },
  {
    courierProviderId: 8,
    courierProviderName: "DTDC",
    stateId: 1,
    stateName: "Kerala",
    criteria: "5kg to 10kg",
    weightSlab: "10kg to 15kg",
    charges: 40.0,
  },
  {
    courierProviderId: 9,
    courierProviderName: "DTDC",
    stateId: 1,
    stateName: "Kerala",
    criteria: "15kg to 20kg",
    weightSlab: "10kg to 15kg",
    charges: 40.0,
  },
  {
    courierProviderId: 10,
    courierProviderName: "DTDC",
    stateId: 1,
    stateName: "Kerala",
    criteria: "20kg above",
    weightSlab: "10kg to 15kg",
    charges: 40.0,
  },
  {
    courierProviderId: 11,
    courierProviderName: "VRL Service",
    stateId: 1,
    stateName: "Kerala",
    criteria: "5kg to 10kg",
    weightSlab: "5kg to 10kg",
    charges: 60.0,
  },
  {
    courierProviderId: 12,
    courierProviderName: "VRL Service",
    stateId: 1,
    stateName: "Kerala",
    criteria: "5kg to 10kg",
    weightSlab: "10kg to 15kg",
    charges: 35.0,
  },
  {
    courierProviderId: 13,
    courierProviderName: "VRL Service",
    stateId: 1,
    stateName: "Kerala",
    criteria: "15kg to 20kg",
    weightSlab: "10kg to 15kg",
    charges: 30.0,
  },
  {
    courierProviderId: 14,
    courierProviderName: "VRL Service",
    stateId: 1,
    stateName: "Kerala",
    criteria: "20kg above",
    weightSlab: "10kg to 15kg",
    charges: 20.0,
  },
];
